// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3D8o2","options":"AnswerScale_options__2WrHq","selected":"AnswerScale_selected__gwQ98"};